'use client';

import {
  ChakraProvider as ChakraProviderDefault,
  defaultSystem,
} from '@chakra-ui/react';
import type { ChakraProviderProps } from '@chakra-ui/react';
import React from 'react';

interface Props extends Omit<ChakraProviderProps, 'value'> {
  cookies?: string;
}

export function ChakraProvider({ cookies, children, ...props }: Props) {
  return (
    <ChakraProviderDefault value={defaultSystem} {...props}>
      {children}
    </ChakraProviderDefault>
  );
}
